<!-- Novo pedir delivery -->
<div *ngIf="isNewHomePedirDelivery" class="new-register-wrapper">

  <div class="new-register-header">
    <button class="new-register-back-button" (click)="backToLogin()">
      <img src="assets/icon/register-back.svg" alt="" />
    </button>
  </div>

  <div class="new-register-body">

    <div class="new-register-intro-container">
      <div class="new-register-intro-icon-wrapper">
        <span class="new-register-intro-icon"></span>
      </div>
      <h2 class="new-register-intro-title">Crie sua conta</h2>
      <p class="new-register-intro-subtitle">Preencha os dados para criar sua conta</p>
    </div>

    <div class="new-register-form-container" [formGroup]="registerForm">

      <div class="new-register-field-container">
        <label class="new-register-field-label">Nome</label>
        <div class="new-register-field-input-wrapper" [ngClass]="{'new-register-field-input-wrapper--invalid': name.invalid && (name.dirty || name.touched)}">
          <span class="new-register-field-icon new-register-field-icon--person"></span>
          <input
            type="text"
            placeholder="Seu nome completo"
            class="new-register-field-input"
            autocomplete="off"
            formControlName="name"
          />
        </div>
        <span *ngIf="name.invalid && (name.dirty || name.touched)" class="new-register-field-error">{{'Invalid Name' | translate}}</span>
      </div>

      <div class="new-register-field-container">
        <label class="new-register-field-label">Email</label>
        <div class="new-register-field-input-wrapper" [ngClass]="{'new-register-field-input-wrapper--invalid': email.invalid && (email.dirty || email.touched)}">
          <span class="new-register-field-icon new-register-field-icon--mail"></span>
          <input
            type="email"
            placeholder="seu@email.com"
            class="new-register-field-input"
            autocomplete="off"
            inputmode="email"
            formControlName="email"
          />
        </div>
        <span *ngIf="email.invalid && (email.dirty || email.touched)" class="new-register-field-error">{{'Invalid Email' | translate}}</span>
      </div>

      <div class="new-register-field-container">
        <label class="new-register-field-label">Senha</label>
        <div class="new-register-field-input-wrapper">
          <span class="new-register-field-icon new-register-field-icon--lock"></span>
          <input
            [type]="showRegisterPassword ? 'text' : 'password'"
            placeholder="••••••••"
            class="new-register-field-input"
            autocomplete="off"
            formControlName="password"
          />
          <button class="new-register-field-eye-button" (click)="showRegisterPassword = !showRegisterPassword">
            <span *ngIf="!showRegisterPassword" class="new-register-field-eye-icon new-register-field-eye-icon--off"></span>
            <span *ngIf="showRegisterPassword" class="new-register-field-eye-icon new-register-field-eye-icon--on"></span>
          </button>
        </div>
        <small class="new-register-field-hint">Uma senha forte contém 8 caracteres, letras e números.</small>
        <password-strength-meter [password]="registerForm.get('password').value" (strengthChange)="onPasswordStrengthChanged($event)"></password-strength-meter>
      </div>

      <div class="new-register-field-container">
        <label class="new-register-field-label">Confirmar senha</label>
        <div class="new-register-field-input-wrapper" [ngClass]="{'new-register-field-input-wrapper--invalid': password.value !== repeatPassword.value && (repeatPassword.dirty || repeatPassword.touched)}">
          <span class="new-register-field-icon new-register-field-icon--lock"></span>
          <input
            [type]="showConfirmPassword ? 'text' : 'password'"
            placeholder="••••••••"
            class="new-register-field-input"
            autocomplete="off"
            formControlName="repeatPassword"
          />
          <button class="new-register-field-eye-button" (click)="showConfirmPassword = !showConfirmPassword">
            <span *ngIf="!showConfirmPassword" class="new-register-field-eye-icon new-register-field-eye-icon--off"></span>
            <span *ngIf="showConfirmPassword" class="new-register-field-eye-icon new-register-field-eye-icon--on"></span>
          </button>
        </div>
        <span *ngIf="password.value !== repeatPassword.value && (repeatPassword.dirty || repeatPassword.touched)" class="new-register-field-error">{{'Passwords do not match!' | translate}}</span>
      </div>

      <button
        class="new-register-primary-button"
        [disabled]="registerForm.invalid || invalidPassword()"
        (click)="createAccount()"
      >
        Criar conta
      </button>

    </div>
  </div>

</div>

<!-- Antigo pedir delivery -->
<ng-container *ngIf="!isNewHomePedirDelivery">
<ion-header>
	<ion-toolbar color="danger">
		<div class="container-header">
			<ion-buttons>
				<ion-button (click)="backToLogin()">
					<ion-icon name="chevron-back-outline"></ion-icon>
				</ion-button>
			</ion-buttons>
			<ion-title class="text-toolbar" translate>Create your account</ion-title>
		</div>
	</ion-toolbar>
</ion-header>

<ion-content class="content-color">
	<section class="body-register">
		<ion-row>
			<ion-col style=" margin: 0 0 10px 0;" size="12" class="ion-text-center">
				<ion-note style="font-size: 13px" translate>A strong password needs at least 8 characters, a letter and a number</ion-note>
			</ion-col>
		</ion-row>

		<ion-form [formGroup]="registerForm">
			<div class="container">
				<div class="center-div-register">
					<ion-row>
						<ion-col size="12">
							<input
								class="form-control"
								type="text"
								placeholder="{{ 'Name' | translate }}"
								type="text"
								name="name"
								autocomplete="off"
								formControlName="name"
								[ngClass]="{'invalid-input': (name.invalid && (name.dirty || name.touched))}"
							>
							<div *ngIf="(name.invalid && (name.dirty || name.touched))">
								<ion-text class="invalid-input-text">{{'Invalid Name' | translate}}</ion-text>
							</div>
						</ion-col>
					</ion-row>
					<ion-row>
						<ion-col size="12">
							<input
								class="form-control"
								type="email"
								placeholder="E-mail"
								type="email"
								name="email"
								autocomplete="off"
								formControlName="email"
								[ngClass]="{'invalid-input': (email.invalid && (email.dirty || email.touched))}"
							>
							<div *ngIf="(email.invalid && (email.dirty || email.touched))">
								<ion-text class="invalid-input-text">{{'Invalid Email' | translate}}</ion-text>
							</div>
						</ion-col>
					</ion-row>

					<ion-row>
						<ion-col size="12">
							<input
								#passwordInput
								class="form-control spacing-input"
								type="password"
								placeholder="{{ 'Password' | translate }}"
								name="password"
								autocomplete="off"
								formControlName="password"
								[ngClass]="{'invalid-input': (password.invalid && (password.dirty || password.touched))}"
								debounce="500"
							>
							<password-strength-meter [password]="registerForm.get('password').value" (strengthChange)="onPasswordStrengthChanged($event)"></password-strength-meter>
						</ion-col>
					</ion-row>
					<ion-row>
						<ion-col size="12">
							<input
								class="form-control"
								type="password"
								placeholder="{{ 'Repeat the password' | translate }}"
								name="repeatPassword"
								autocomplete="off"
								formControlName="repeatPassword"
								[ngClass]="{'invalid-input': (password.value!=repeatPassword.value && (repeatPassword.dirty || repeatPassword.touched))}"
							>
							<div *ngIf="password.value!=repeatPassword.value && (repeatPassword.dirty || repeatPassword.touched)">
								<ion-text class="invalid-input-text">{{'Passwords do not match!' | translate}}</ion-text>
							</div>
						</ion-col>
					</ion-row>
				</div>

				<div class="entry-buttons">
					<ion-button color="danger" expand="block" class="button-register" strong="true" mode="ios" translate [disabled]="registerForm.invalid || invalidPassword()" (click)="createAccount()">Register</ion-button>
				</div>
			</div>
		</ion-form>
	</section>
</ion-content>
</ng-container>
